import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';

@Component({
  selector: 'app-danger-modal',
  templateUrl: './danger-modal.component.html',
  styleUrls: ['./danger-modal.component.css']
})
export class DangerModalComponent implements OnInit {
  message: string;
  constructor(public bsModalRef: BsModalRef) {} 

  ngOnInit() {
    
  }  
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/shared/components/danger-modal/danger-modal.component.ts